/**
 * Get the Application root element.
 * This is used by some Backpack components when displayed full screen
 *
 * @returns {DOM} root element
 */
export const getApplicationElement = () => document.getElementById('app-root');

export const getModalRootElement = (id: string) => document.getElementById(id);
